import { useState, useCallback } from 'react';
import clsx from 'clsx';
import Container from '@/components/Container';
import EventGalleryItem from './EventGalleryItem';

const EventGalleryControl = ({
  className,
  onClick,
  children,
}) => (
  <div className={clsx('h-full absolute z-10 top-0 flex items-center', className)}>
    <button className="w-10 h-10 lg:w-12 lg:h-12 bg-green-600 hover:bg-green-500 transition ease-in-out duration-300 rounded-full flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:ring-offset-gray-900" onClick={onClick} type="button">
      {children}
    </button>
  </div>
);

const EventGalleryPrevControl = (props) => (
  <EventGalleryControl className="left-0" {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="17px" height="15px">
      <g fill="none" fillRule="evenodd">
        <g fill="#FFFFFF">
          <path d="M5.67 6h9.83a1.5 1.5 0 1 1 0 3H5.67l3.44 3.44a1.5 1.5 0 0 1 0 2.12c-.59.59-1.53.59-2.11 0L0 7.5 7 .44a1.49 1.49 0 0 1 2.1 0 1.5 1.5 0 0 1 0 2.12L5.68 6z" />
        </g>
      </g>
    </svg>
  </EventGalleryControl>
);

const EventGalleryNextControl = (props) => (
  <EventGalleryControl className="right-0" {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="17px" height="15px">
      <g fill="none" fillRule="evenodd">
        <g fill="#FFFFFF">
          <path d="M11.33 6H1.5a1.5 1.5 0 1 0 0 3h9.83l-3.44 3.44a1.5 1.5 0 0 0 0 2.12c.59.59 1.53.59 2.11 0l7-7.06-7-7.06a1.49 1.49 0 0 0-2.1 0 1.5 1.5 0 0 0 0 2.12L11.32 6z"></path>
        </g>
      </g>
    </svg>
  </EventGalleryControl>
);

export default function EventGallery({
  photos,
}) {
  const [active, setActive] = useState(0);

  const activatePhoto = useCallback((to) => {
    const lastIndex = photos.length - 1;
    let activeIndex = to;

    if (activeIndex < 0) {
      activeIndex = lastIndex;
    } else if (activeIndex > lastIndex) {
      activeIndex = 0;
    }

    setActive(activeIndex);
  }, []);

  const onPrevClick = useCallback(() => activatePhoto(active - 1), [active]);

  const onNextClick = useCallback(() => activatePhoto(active + 1), [active]);

  return (
    <div className="flex flex-col w-full bg-gray-900 text-white">
      <Container className="py-10 lg:py-14">
        <div className="relative w-full">
          <EventGalleryPrevControl onClick={onPrevClick} />
          <EventGalleryNextControl onClick={onNextClick} />
          <div className="px-10 relative z-0 max-w-screen-lg mx-auto">
            <div className="aspect-w-16 aspect-h-9 relative">
              {photos.map(({ id, ...picture }, index) => (
                <EventGalleryItem
                  key={id}
                  active={index === active}
                  index={index}
                  {...picture}
                />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
